import { mutatorAction } from 'satcheljs';
import { getCollabSpaceStore } from '../store/store';
import { setFileNameFromSharingInfo } from '../utils/setFileNameFromSharingInfo';
import { IsSharedType } from '../store/schema';
import { getViewStateById } from '../selectors/collabSpaceSelectors';

export const initCollabSpaceViewState = mutatorAction(
    'initCollabSpaceViewState',
    (
        shareLink: string | null,
        collabAllowed: boolean | null,
        isShared: IsSharedType,
        viewStateId: string
    ) => {
        if (shareLink?.length > 0) {
            setFileNameFromSharingInfo(shareLink, viewStateId);

            const viewState = getViewStateById(viewStateId);
            if (viewState) {
                viewState.shareLink = shareLink;
                viewState.isShared = isShared;
                viewState.collabAllowed = collabAllowed ?? true;
                viewState.isCollabSpacePresent = true;
            }
        }
    }
);

export const addShareLink = mutatorAction(
    'addShareLink',
    (shareLink: string, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.shareLink = shareLink;
        }
    }
);

export const setFileName = mutatorAction('setFileName', (fileName: string, viewStateId: string) => {
    const viewState = getViewStateById(viewStateId);

    if (viewState) {
        viewState.fileName = fileName;
    }
});

export const setIsCollabSpacePresent = mutatorAction(
    'setIsCollabSpacePresent',
    (isCollabSpacePresent: boolean, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.isCollabSpacePresent = isCollabSpacePresent;
        }
    }
);

export const setIsCollabAllowed = mutatorAction(
    'setIsCollabAllowed',
    (collabAllowed: boolean, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            if (collabAllowed) {
                viewState.isCollabSpaceExplicitlyDisabled = false;
            }
            viewState.collabAllowed = collabAllowed;
        }
    }
);

export const setIsCollabSpaceExplicitlyDisabled = mutatorAction(
    'setIsCollabSpaceExplicitlyDisabled',
    (value: boolean, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.isCollabSpaceExplicitlyDisabled = value;
        }
    }
);

export const setIsShared = mutatorAction(
    'setIsShared',
    (isShared: IsSharedType, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.isShared = isShared;
        }
    }
);

export const setIsNewDoc = mutatorAction('isNewDoc', (isNewDoc: boolean, viewStateId: string) => {
    const viewState = getViewStateById(viewStateId);

    if (viewState) {
        viewState.isNewDoc = isNewDoc;
    }
});

export const setFluidLinkFailed = mutatorAction(
    'setFluidLinkFailed',
    (fluidLinkFailed: boolean, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.fluidLinkFailed = fluidLinkFailed;
        }
    }
);

export const setSeriesMasterShareLink = mutatorAction(
    'setSeriesMasterShareLink',
    (seriesMasterShareLink: string, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.seriesMasterShareLink = seriesMasterShareLink;
        }
    }
);

export const setSeriesInstanceShareLink = mutatorAction(
    'setSeriesInstanceShareLink',
    (seriesInstanceShareLink: string, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.seriesInstanceShareLink = seriesInstanceShareLink;
        }
    }
);

export const resetCollabSpaceStore = mutatorAction(
    'resetCollabSpaceStore',
    (viewStateId: string) => {
        if (getCollabSpaceStore().entries.has(viewStateId)) {
            const viewState = getViewStateById(viewStateId);

            if (viewState) {
                viewState.shareLink = null;
                viewState.fileName = null;
                viewState.isCollabSpacePresent = false;
                viewState.collabAllowed = null;
                viewState.isNewDoc = false;
                viewState.isShared = null;
                viewState.fluidLinkFailed = false;
                viewState.isCollabSpaceExplicitlyDisabled = false;
                viewState.meetingsFolderAccessFailed = false;

                getCollabSpaceStore().entries.set(viewStateId, viewState);
            }
        }
    }
);

export const removeViewStateFromCollection = mutatorAction(
    'removeViewStateFromCollection',
    (viewStateId: string) => {
        if (getCollabSpaceStore().entries.has(viewStateId)) {
            getCollabSpaceStore().entries.delete(viewStateId);
        }
    }
);

export const setMeetingsFolderAccessFailed = mutatorAction(
    'setMeetingsFolderAccessFailed',
    (meetingsFolderAccessFailed: boolean, viewStateId: string) => {
        const viewState = getViewStateById(viewStateId);

        if (viewState) {
            viewState.meetingsFolderAccessFailed = meetingsFolderAccessFailed;
        }
    }
);
